import { render, staticRenderFns } from "./MemberActivityDetails.vue?vue&type=template&id=fb8795f8&scoped=true"
import script from "./MemberActivityDetails.vue?vue&type=script&lang=js"
export * from "./MemberActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberActivityDetails.vue?vue&type=style&index=0&id=fb8795f8&prod&scoped=true&lang=css"
import style1 from "./MemberActivityDetails.vue?vue&type=style&index=1&id=fb8795f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8795f8",
  null
  
)

export default component.exports